import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import adminService from "../../api/services/adminService";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import logo1 from "../../assests/logo1.png";
import { FiEye, FiEyeOff } from "react-icons/fi";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {
    const emailTrimmed = email.trim();
    const passwordTrimmed = password.trim();
    const isEmailValid = /.+@.+\..+/.test(emailTrimmed);

    if (!emailTrimmed || !passwordTrimmed) {
      toast.error("Please fill in all required fields!");
      return;
    }
    if (!isEmailValid) {
      toast.error("Please enter a valid email address!");
      return;
    }

    const toastId = toast.loading("Signing in...");
    try {
      const res = await adminService.login({
        email: emailTrimmed,
        password: passwordTrimmed,
      });
      console.log("Login response:", res);

      // Clear any existing tokens and localStorage first to avoid conflicts
      Cookies.remove("token");
      Cookies.remove("naseebiadmin");
      localStorage.clear(); // Clear all localStorage to remove any old user data

      // Store the admin token
      if (res?.token) {
        Cookies.set("token", res.token, { expires: 365 }); // 1 year expiry
        // Also store in naseebiadmin cookie for consistency
        Cookies.set("naseebiadmin", res.token, { expires: 365 });
        console.log("Admin token stored successfully");
      }

      if (res?.user) {
        localStorage.setItem("adminUserDetails", JSON.stringify(res.user));
        // Store role for role-based access control
        if (res.user.role) {
          localStorage.setItem("adminUserRole", res.user.role);
        }
      }

      toast.success("Logged in successfully!");
      navigate("/dashboard", { replace: true });
    } catch (e) {
      const message = e?.message || e?.error || e?.msg || "Login failed";
      toast.error(
        typeof message === "string" ? message : "Unknown error occurred!"
      );
    } finally {
      toast.dismiss(toastId);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#F2F6FA] p-4">
      <div className="w-full max-w-[560px]">
        <div className="flex flex-col items-center mb-6">
          <img src={logo1} alt="Naseebi" className="h-14 w-auto" />
        </div>

        <div className="bg-white rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.08)] px-8 py-10">
          <h1 className="text-[#0F172A] text-[36px] leading-none font-[700] text-center mb-8">
            Login
          </h1>

          <div className="space-y-6">
            <div>
              <label className="block text-[15px] font-[600] text-gray-700 mb-2">
                Email *
              </label>
              <input
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="Email"
                className="w-full h-12 rounded-lg border border-gray-200 px-4 focus:outline-none focus:ring-2 focus:ring-[#FB565F] focus:border-transparent placeholder:text-gray-400"
              />
            </div>

            <div>
              <label className="block text-[15px] font-[600] text-gray-700 mb-2">
                Password *
              </label>
              <div className="relative">
                <input
                  onChange={(e) => setPassword(e.target.value)}
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className="w-full h-12 rounded-lg border border-gray-200 px-4 pr-12 focus:outline-none focus:ring-2 focus:ring-[#FB565F] focus:border-transparent placeholder:text-gray-400"
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  onClick={() => setShowPassword((v) => !v)}>
                  {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                </button>
              </div>
            </div>

            <button
              className="w-full h-12 rounded-lg bg-[#FB2F38] hover:bg-[#e42831] text-white font-[700] tracking-wide transition-colors"
              onClick={() => handleLogin()}>
              LOGIN
            </button>

            <div className="text-center">
              <button
                type="button"
                onClick={() => navigate("/forgot-password")}
                className="text-[#D12A30] text-sm font-[600] hover:underline">
                Forgot password?
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
